<template>
  <div class="flex min-h-screen font-sans">
    <!-- Section gauche - Branding -->
    <div class="flex-1 bg-gradient-to-br from-primary-dark to-primary flex items-center justify-center p-10 relative overflow-hidden">
      <div class="absolute w-[500px] h-[500px] bg-white/10 rounded-full -top-24 -left-24"></div>
      <div class="absolute w-[400px] h-[400px] bg-white/5 rounded-full -bottom-24 -right-24"></div>

      <div class="relative z-10 text-center text-white">
        <div class="mb-8">
          <BaseIcon name="exclamation-triangle" :size="80" class="mb-6 opacity-90" />
        </div>
        <h2 class="text-5xl font-bold mb-4 leading-tight text-white">
          Licence expirée
        </h2>
        <p class="text-lg opacity-90 font-light">
          Votre abonnement nécessite un renouvellement
        </p>
      </div>
    </div>

    <!-- Section droite - Contenu -->
    <div class="flex-1 flex items-center justify-center p-10 bg-white">
      <div class="w-full max-w-[440px]">
        <div class="mb-10">
          <h1 class="text-gray-900 text-3xl font-bold mb-2">
            Accès suspendu
          </h1>
          <p class="text-gray-500 text-base">
            {{ message }}
          </p>
        </div>

        <div class="bg-amber-10 text-dark border border-primary-200 rounded-lg p-6 mb-6 text-sm">
          <p class="font-medium mb-2 text-dark">Que faire ?</p>
          <ul class="list-disc list-inside space-y-1 text-dark">
            <li>Contactez l'administrateur de votre entreprise</li>
            <li>Renouvelez votre abonnement auprès de votre fournisseur</li>
            <li>En cas de question, contactez le support Digita (+221 76 556 93 00)</li>
          </ul>
        </div>

        <BaseButton
          variant="primary"
          size="lg"
          block
          @click="handleRetry"
          :loading="isChecking"
          class="hover:-translate-y-0.5 active:translate-y-0 transition-transform mb-3"
        >
          <template #icon-left>
            <BaseIcon name="refresh" :size="16" />
          </template>
          {{ isChecking ? 'Vérification...' : 'Réessayer' }}
        </BaseButton>

        <button
          type="button"
          class="w-full inline-flex items-center justify-center gap-2 px-5 py-2.5 text-sm font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
          @click="$router.push({ name: 'login' })"
        >
          <BaseIcon name="arrow-left" :size="16" />
          Retour à la connexion
        </button>

        <footer class="text-center text-gray-400 text-xs pt-6 mt-8 border-t border-gray-200">
          <p class="mb-2">
            © {{ new Date().getFullYear() }} SellHub. Tous droits réservés.
          </p>
          <div class="flex items-center justify-center text-xs">
            <span>Powered by </span>
            <a
              href="https://digita.sn"
              target="_blank"
              class="text-secondary font-semibold ml-1 hover:text-primary transition-colors"
            >
              Digita SN
            </a>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import ApiService from '@/services/apiService'
import BaseButton from '@/components/base/BaseButton.vue'
import BaseIcon from '@/components/base/BaseIcon.vue'

const defaultMessage = 'Votre licence a expiré. Veuillez contacter l\'administrateur pour renouveler votre abonnement.'

export default defineComponent({
  name: 'LicenseExpiredView',
  components: {
    BaseButton,
    BaseIcon
  },
  setup() {
    const router = useRouter()
    const isChecking = ref(false)
    const customMessage = ref(null)

    const message = computed(() => customMessage.value || defaultMessage)

    const handleRetry = async () => {
      isChecking.value = true
      try {
        await ApiService.get('/auth/me')
        sessionStorage.removeItem('license_expired')
        router.push({ name: 'dashboard' })
      } catch (error) {
        if (error.response?.status === 403 && error.response?.data?.license_status === 'no_valid_license') {
          customMessage.value = error.response?.data?.message || defaultMessage
          sessionStorage.setItem('license_expired', 'true')
        }
      } finally {
        isChecking.value = false
      }
    }

    return {
      message,
      isChecking,
      handleRetry
    }
  }
})
</script>

<style scoped>
@media (max-width: 968px) {
  .flex {
    flex-direction: column;
  }
}
</style>
